// src/App.js


import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { WishlistProvider } from './context/WishlistContext';
import { AuthProvider } from './context/AuthContext'; // ✅ NEW: Authentication Context
import PayPalUSDWrapper from './components/PayPalUSDWrapper'; 


import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import ScrollToTop from './components/ScrollToTop';
import ScrollToTopButton from './components/ScrollToTopButton';
import ChatBot from './components/ChatBot';
import Home from './pages/Home';
import About from './pages/About';
import Products from './pages/Products';
import ProductsList from './pages/ProductsList'; // ✅ NEW: Product listing page
import ProductDetail from './pages/ProductDetail';
import Contact from './pages/Contact';
import Specialist from './pages/Specialist';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';

import Account from './pages/Account'; // ✅ NEW: Account page
import Wishlist from './pages/Wishlist'; // ✅ NEW: Wishlist page
import TrackOrder from './pages/TrackOrder'; // ✅ NEW: Track Order page
import VerifyEmail from './pages/VerifyEmail'; // ✅ NEW: Email verification page
import NotFound from './pages/NotFound'; // ✅ NEW: 404 page
import './styles/globals.css';



function App() {
  return (
    <AuthProvider> {/* ✅ NEW: Authentication Provider */}
      <PayPalUSDWrapper>
        <CartProvider>
          <WishlistProvider>
            <Router>
              <ScrollToTop />
              <div className="App">
                <Header />
                <main>
                  <Routes>
                    {/* Main Routes */}
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/specialist" element={<Specialist />} />

                    <Route path="/cart" element={<Cart />} />
                    <Route path="/checkout" element={<Checkout />} />
                    <Route path="/account" element={<Account />} />
                    <Route path="/wishlist" element={<Wishlist />} />
                    <Route path="/track-order" element={<TrackOrder />} />
                    <Route path="/verify" element={<VerifyEmail />} />
                    
                    {/* Product Routes */}
                    <Route path="/products" element={<ProductsList />} /> {/* ✅ Changed from Products to ProductsList */}
                    <Route path="/products/category/:category" element={<ProductsList />} />
                    <Route path="/products/brand/:brand" element={<ProductsList />} />
                    <Route path="/products/type/:type" element={<ProductsList />} />
                    <Route path="/product/:id" element={<ProductDetail />} />
                    
                    {/* Legacy route (if you want to keep compatibility) */}
                    <Route path="/products-old" element={<Products />} />
                    
                    {/* 404 Route */}
                    <Route path="*" element={<NotFound />} />
                  </Routes>


                </main>
                <Footer />
                <ScrollToTopButton />
                <ChatBot />
              </div>
            </Router>
          </WishlistProvider>
        </CartProvider>
      </PayPalUSDWrapper>
    </AuthProvider>
  );
}


export default App;